import 'navigator.locks';
import env from '../config/variables';
import { log, LOG_LEVELS } from '../../common/config/app_logger';
import { paramOrNul, getData, calculateDifference } from '../../common/config/utils';
import { getCurrentLocalization } from '../config/i18n';
import { isPrerenderMode, getDateFromServerUTC } from '../config/util';

const { HOTJAR_ID, BACKEND_VERSION, NEED_TRACKING_HOTJAR } = env;

let hotJarInitialized;
let hotjarInstance;

const getHotjarInstance = (callback) => {
  navigator.locks.request('hotjarInstance', async () => {
    if (!hotjarInstance) {
      const { hotjar } = await import('react-hotjar');
      hotjarInstance = hotjar;
    }
    callback(hotjarInstance);
  });
};

export const getUserAttributes = ({ user }) => {
  const language = getCurrentLocalization();
  const { dynamicConfig } = window.store.getState().application;
  const date = getDateFromServerUTC(dynamicConfig?.utc);
  let baseAttributes = {
    'day of week': getData({ date, type: 'day' }),
    'hour of day': getData({ date, type: 'hours' }),
    year: getData({ date, type: 'year' }),
    month: getData({ date, type: 'month' }),
    'year-month': `${ getData({ date, type: 'year' }) }-${ getData({ date, type: 'month' }) }`,
    ...paramOrNul('language', language)
  };

  if (user && Object.keys(user).length !== 0) {
    const baseUserAttributes = {
      'user type': 'client',
      'credit balance': parseFloat(user.clientAvailableCredit),
      'total purchased': parseFloat(user.totalPurchased),
      'total purchase fees paid': parseFloat(user.totalPurchaseFeesPaid),
      'purchases count': user.purchasesCount,
      ...paramOrNul('last purchase date', user.lastPurchaseDate),
      email: user.email,
      'login type': user.loginType?.replaceAll('_', ' '),
      ...paramOrNul('gender', user.gender),
      ...paramOrNul('age', calculateDifference({ date1: date, date2: user.dateOfBirth, type: 'years' })),
      ...paramOrNul('install date', user.installDate),
      'days from install': calculateDifference({ date1: date, date2: user.installDate, type: 'days' }),
      'signup date': user.createdAt,
      'days from signup': calculateDifference({ date1: date, date2: user.createdAt, type: 'days' }),
      'backend version': parseInt(BACKEND_VERSION, 10),
      ...paramOrNul('paypal total charged', user.paypalTotalCharged),
      ...paramOrNul('credit card total charged', user.creditCardTotalCharged)
    };
    baseAttributes = { ...baseAttributes, ...baseUserAttributes };
  } else {
    baseAttributes['user type'] = 'anonymous';
  }
  return baseAttributes;
};

export const hotJarInitialize = () => {
  if (!NEED_TRACKING_HOTJAR) return;
  if (isPrerenderMode()) return;
  getHotjarInstance((hotjar) => {
    hotjar.initialize(HOTJAR_ID);
    hotJarInitialized = true;
    log(LOG_LEVELS.INFO, 'Hotjar', 'initialize');
  });
};

export const hotJarIdentifyUser = ({ user }) => {
  getHotjarInstance((hotjar) => {
    if (!hotJarInitialized) return;
    const userAttributes = getUserAttributes({ user });
    hotjar.identify(`${ user.id }`, { ...userAttributes });
    log(LOG_LEVELS.INFO, 'Hotjar', 'identifyUser');
  });
};

export const hotJarReset = () => {
  getHotjarInstance((hotjar) => {
    if (!hotJarInitialized) return;
    const userAttributes = getUserAttributes({});
    hotjar.identify(null, { ...userAttributes });
    log(LOG_LEVELS.INFO, 'Hotjar', 'reset');
  });
};
